import React from 'react';
import { View, Image, StyleSheet, TouchableOpacity, Platform, Dimensions, Text } from 'react-native';
import Colors from '../constants/Colors';
import CS from '../constants/Styles';
import { AntDesign } from '@expo/vector-icons';
import Storage from './Storage';
import PDFReader from 'rn-pdf-reader-js';

export default function PhotoId({ ...props }) {

  const windowWidth = Dimensions.get('window').width;

  const [headers, setHeaders] = React.useState({});
  React.useEffect(() => {
    (async () => {
      const rtJWT = await Storage.getItem('rtJWT');
      setHeaders({ 'Authorization': `Bearer ${rtJWT}` });
    })()
  }, []);
  
  const imgStyle = () => {
    const ratio1 = props.width / props.height;
    const ratio2 = props.height / props.width;
    if(Platform.OS === 'web'){
      const width = windowWidth > 768 ? 768 : windowWidth;
      const height = width * ratio2;
      // return {
      //   width: props.width,
      //   height: props.height,
      // }
      return {
        width: width,
        height: height,
      }
    }
    return {
      aspectRatio: ratio1
    }
  }

  const removeContent = (isAbsolute) => {
    if(props.remove){
      return (
        <TouchableOpacity style={styles.removeContainer} onPress={() => props.remove(props.uri)} activeOpacity={0.5} hitSlop={{ top: 30, bottom: 30, left: 30, right: 30 }} >
        {/* <TouchableOpacity style={styles.removeContainer} onPress={() => console.log('remove test:', props.uri)} activeOpacity={0.5} > */}
          <AntDesign name="closecircleo" size={36} color='white' style={styles.removeIcon2} />
          <AntDesign name="closecircle" size={36} color={Colors.red} style={styles.removeIcon2} />
        </TouchableOpacity>
      )
    }
    return null;
  }

  if(props.fileType === 'image'){
    return (
      <View style={styles.container}>
        <Image source={{ uri: props.uri }} style={[styles.img, imgStyle()]} />
        {removeContent(true)}
      </View>
    );
  }else if (props.fileType === 'pdf'){
    // if(Platform.OS === 'web'){
      return (
        <View style={styles.container}>
          <Text style={[CS.smallText, CS.lightBlueText, { paddingVertical: 15 }]}>{props.fileName}</Text>
          {removeContent(false)}
        </View>
      )
    // }
    // return (
    //   <View style={[styles.container, styles.pdfContainer]}>
    //     <PDFReader source={{ uri: props.uri, headers: headers }} />
    //     {removeContent(true)}
    //   </View>
    // )
  }
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    marginBottom: 10,
    position:'relative',
    borderRadius: 10,
    borderStyle: 'solid',
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    overflow: 'hidden',
    width: '100%',
  },
  pdfContainer: {
    height: 1000,
    flex: 1,
  },
  img: {
    width: '100%',
    // height: 200,
    borderRadius: 10,
  },
  removeContainer: {
    position:'absolute',
    top: 5,
    right: 5,
    borderTopRightRadius: 10,
    zIndex: 10,
    flex: 1,
  },
  removeIcon2: {
    position:'absolute',
    top:0,
    right:0,
  },
});

